module.exports = __webpack_public_path__ + "static/img/yd-bg2.e3fc89b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-bg2.png
// module id = Y+ls
// module chunks = 0